/** API route map: URLS.Controller.Main */
export const Main = {
      Name: 'Main/',
      GetUserApplicationRights: 'GetUserApplicationRights',
      GetUserDetail: 'GetUserDetail',
      GetAll: 'GetCompanyUsers',
};
